import React from 'react';
import DealCreate from '../../components/TabsAll/Sponsor/DealCreate/DealCreate';
import DueDilliegnce from '../../components/TabsAll/Sponsor/DueDilligence/DueDilligence';
import SponsorProfile from '../../components/TabsAll/Sponsor/SponsorProfile/SponsorProfile';
import { Tabs, Tab, TabList, TabPanel } from '../../components/TabsAll/Tabs/Tabs';
import Messages from '../../components/TabsAll/Account/Messages/Messages';
import { CgProfile } from "react-icons/cg";
import {CgMail} from "react-icons/cg";

function Sponsor() {
  
  return (
    <Tabs>
      <TabList>
        <Tab index={0}>Create Your Deal</Tab>
        <Tab index={2}>Documents</Tab> 
        <Tab index={3}><CgMail size={16} /></Tab>  
        <Tab index={4}><CgProfile size={16} /></Tab>  
        

      </TabList>
      
      <TabPanel index={0}><DealCreate/></TabPanel>
      <TabPanel index={2}><DueDilliegnce/></TabPanel>
      <TabPanel index={3}><Messages /></TabPanel>
      <TabPanel index={4}><SponsorProfile /></TabPanel>  
    </Tabs>
  );
}
export default Sponsor

